const blockSchema = {
  type: 'object',
  properties: {
    block_type: {
      type: 'string',
      enum: [
        'media',
        'heading',
        'body_text',
        'list_item',
        'spec_table',
        'stat_group',
        'icon_grid',
        'accordion',
        'tabs',
        'cta',
        'testimonial',
        'badge_stamp',
        'tag_pills',
        'disclaimer_text',
        'rating_badge',
        'promo_pill',
        'comparison_table',
      ],
    },
    order: { type: 'integer', description: 'Thứ tự block trong cột/stack/card, bắt đầu từ 0' },

    media: {
      type: 'object',
      description: "block_type='media'",
      properties: {
        url: {
          type: 'string',
          description:
            "URL nguồn thật của media. Với ảnh: lấy từ 'src'. Với video: lấy từ thuộc tính 'src' HOẶC 'data-src' của thẻ <source> bên trong <video> (KHÔNG lấy từ 'poster'). Nếu video có nhiều <source>, ưu tiên type='video/mp4', chỉ dùng type='application/x-mpegURL' (.m3u8) nếu không có mp4.",
        },
        poster_url: {
          type: 'string',
          description:
            "CHỈ dùng khi media_type='video'. Lấy từ thuộc tính 'poster' của thẻ <video>, dùng làm ảnh đại diện/thumbnail hiển thị trước khi video phát. Để '' nếu không có.",
        },
        alt: { type: 'string' },
        media_type: { type: 'string', enum: ['image', 'gif', 'video'] },
      },
      required: ['url', 'media_type'],
    },

    text: {
      type: 'string',
      description:
        "block_type='heading' | 'body_text' | 'disclaimer_text'. Giữ nguyên rich text HTML inline nếu có. Với giá tiền/số liệu: COPY CHÍNH XÁC từng ký tự, KHÔNG tự thay đổi/làm tròn bất kỳ chữ số nào. Nếu có 2 giá trị đi liền nhau (giá bán - giá gốc), ghép thành 1 chuỗi 'giá1 - giá2' theo ĐÚNG THỨ TỰ xuất hiện trong HTML",
    },

    list_item_items: {
      type: 'array',
      description: "block_type='list_item': mục có tiêu đề + mô tả, thường kèm icon minh hoạ",
      items: {
        type: 'object',
        properties: {
          icon_url: { type: 'string', description: "để '' nếu không có" },
          title: { type: 'string', description: "để '' nếu không có tiêu đề riêng" },
          description: { type: 'string' },
        },
        required: ['description'],
      },
    },

    spec_table_items: {
      type: 'array',
      description: "block_type='spec_table': bảng nhãn-giá trị ngắn gọn, không icon, không mô tả dài",
      items: {
        type: 'object',
        properties: {
          label: { type: 'string' },
          value: { type: 'string' },
        },
        required: ['label', 'value'],
      },
    },

    stat_items: {
      type: 'array',
      description:
        "block_type='stat_group': số liệu lớn (%, số) kèm mô tả, mang tính chứng minh/quảng cáo. Có thể có title riêng hoặc không tuỳ nguồn",
      items: {
        type: 'object',
        properties: {
          value: { type: 'string' },
          title: {
            type: 'string',
            description: "tiêu đề riêng đi kèm value nếu có, để '' nếu nguồn không có title riêng",
          },
          description: { type: 'string' },
          icon_or_badge_url: { type: 'string', description: "để '' nếu không có" },
        },
        required: ['value', 'description'],
      },
    },

    icon_grid_items: {
      type: 'array',
      description:
        "block_type='icon_grid': lưới icon nhỏ + tiêu đề + mô tả ngắn, dùng khi là 1 PHẦN của section lớn hơn",
      items: {
        type: 'object',
        properties: {
          icon_url: { type: 'string' },
          title: { type: 'string' },
          subtitle: { type: 'string' },
        },
        required: ['title'],
      },
    },

    accordion_items: {
      type: 'array',
      description:
        "block_type='accordion': nội dung mở/thu gọn được (dùng trong side_by_side/hero_banner/text_media_stack, KHÔNG dùng cho type_signal='faq_accordion')",
      items: {
        type: 'object',
        properties: {
          title: { type: 'string' },
          content: { type: 'string' },
          is_expanded_default: { type: 'boolean' },
        },
        required: ['title', 'content'],
      },
    },

    tab_items: {
      type: 'array',
      description: "block_type='tabs': các nút chọn ngang hàng dạng pill/tab",
      items: {
        type: 'object',
        properties: {
          label: { type: 'string' },
          is_active_default: { type: 'boolean' },
        },
        required: ['label'],
      },
    },

    cta_items: {
      type: 'array',
      description: "block_type='cta'",
      items: {
        type: 'object',
        properties: {
          label: { type: 'string' },
          url: { type: 'string' },
          style_hint: { type: 'string', enum: ['primary', 'secondary'] },
          sub_text: { type: 'string', description: 'text phụ dưới nút nếu có' },
        },
        required: ['label'],
      },
    },

    testimonial_data: {
      type: 'object',
      description:
        "block_type='testimonial': dùng khi chỉ có 1-2 testimonial ĐƠN LẺ xen giữa nội dung khác trong side_by_side/hero_banner/carousel/text_media_stack. KHÔNG dùng cho cả 1 danh sách review đầy đủ có summary riêng — trường hợp đó dùng type_signal='review_list'",
      properties: {
        author: { type: 'string' },
        content: { type: 'string' },
        rating: { type: 'number' },
        avatar_url: { type: 'string' },
        verified: { type: 'boolean', description: "true nếu có badge 'Verified Buyer' hoặc tương đương" },
      },
    },

    badge_stamp_data: {
      type: 'object',
      description: "block_type='badge_stamp': tem/huy hiệu nhỏ đè lên ảnh",
      properties: {
        image_url: { type: 'string' },
        text: { type: 'string' },
      },
    },

    tag_pills_items: {
      type: 'array',
      description: "block_type='tag_pills': lưới nhãn ngắn dạng pill",
      items: {
        type: 'object',
        properties: {
          label: { type: 'string' },
          icon: { type: 'string', enum: ['check', 'cross', 'none'] },
        },
        required: ['label'],
      },
    },

    rating_data: {
      type: 'object',
      description: "block_type='rating_badge': dòng sao đánh giá + text tin cậy",
      properties: {
        rating_value: { type: 'number' },
        rating_max: { type: 'number' },
        text: { type: 'string' },
      },
      required: ['rating_value'],
    },

    promo_pill_data: {
      type: 'object',
      description: "block_type='promo_pill': nhãn nhỏ nổi bật dạng pill có nền màu riêng, vd 'SALE', 'SOLD OUT'",
      properties: {
        text: { type: 'string' },
      },
      required: ['text'],
    },

    comparison_table_data: {
      type: 'object',
      description:
        "block_type='comparison_table': bảng so sánh sản phẩm mình với đối thủ, mỗi hàng 1 tiêu chí, mỗi cột 1 đối tượng so sánh",
      properties: {
        competitor_columns: {
          type: 'array',
          description: 'Tên các cột so sánh theo đúng thứ tự trái→phải',
          items: { type: 'string' },
        },
        rows: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              label: { type: 'string' },
              icon_url: { type: 'string', description: "icon/emoji đi kèm label nếu có, để '' nếu không có" },
              values: {
                type: 'array',
                description: 'Giá trị tương ứng từng cột, ĐÚNG THỨ TỰ và ĐÚNG SỐ LƯỢNG với competitor_columns',
                items: {
                  type: 'string',
                  enum: ['check', 'cross', 'partial', ''],
                  description: "'' nếu ô đó là text/số thay vì icon",
                },
              },
            },
            required: ['label', 'values'],
          },
        },
        highlighted_column_index: {
          type: 'integer',
          description: 'Chỉ số cột nổi bật (thường là sản phẩm chính), -1 nếu không có',
        },
      },
      required: ['competitor_columns', 'rows'],
    },
  },
  required: ['block_type', 'order'],
};

const sectionSchema = {
  type: 'object',
  properties: {
    type_signal: {
      type: 'string',
      enum: [
        'side_by_side',
        'hero_banner',
        'marquee',
        'media_center_grid',
        'faq_accordion',
        'carousel',
        'feature_grid_media',
        'icon_grid_row',
        'stat_list',
        'review_list',
        'freestyle_content',
        'text_media_stack',
        'unknown',
      ],
    },
    order: {
      type: 'integer',
      description: 'Thứ tự xuất hiện trong DOM, bắt đầu từ 0',
    },

    layout: {
      type: 'object',
      properties: {
        column_count: { type: 'integer', description: 'Số cột thực tế trong DOM, KHÔNG giới hạn ở 2' },
        media_column: { type: 'string', enum: ['left', 'right', 'none'] },

        background_media: {
          type: 'object',
          properties: {
            url: {
              type: 'string',
              description:
                "Với video: lấy từ 'src'/'data-src' của <source>, ưu tiên type='video/mp4'. KHÔNG lấy từ 'poster'.",
            },
            poster_url: {
              type: 'string',
              description: "CHỈ dùng khi media_type='video'. Lấy từ thuộc tính 'poster' của <video>.",
            },
            media_type: { type: 'string', enum: ['image', 'gif', 'video'] },
          },
        },
        text_position: { type: 'string', enum: ['left', 'center', 'right'] },
        overlay_darkness: { type: 'string', enum: ['none', 'light', 'dark'] },
        text_color_hint: { type: 'string', enum: ['light', 'dark'] },

        marquee_item_style: {
          type: 'string',
          enum: ['text_badge', 'pill', 'logo'],
        },
        scroll_direction: { type: 'string', enum: ['left', 'right', 'none'] },

        items_per_side: { type: 'integer' },

        faq_style: { type: 'string', enum: ['numbered', 'plain'] },
        expand_icon: { type: 'string', enum: ['chevron', 'plus_minus', 'none'] },

        card_count: { type: 'integer' },
        cards_visible_hint: { type: 'integer' },

        primary_media_position: { type: 'string', enum: ['left', 'right', 'none'] },
        grid_columns: { type: 'integer' },
        grid_rows: { type: 'integer' },
        card_style: { type: 'string', enum: ['media_overlay', 'media_inline'] },

        item_count: { type: 'integer' },

        summary_position: {
          type: 'string',
          enum: ['left', 'right', 'top', 'none'],
        },
        review_count_visible: { type: 'integer' },

        // ---- freestyle_content ----
        has_video: { type: 'boolean', description: 'true nếu nội dung có chèn video' },
        image_count: { type: 'integer', description: 'Số lượng ảnh xuất hiện trong nội dung' },

        // ---- text_media_stack ----
        text_align: {
          type: 'string',
          enum: ['left', 'center', 'right'],
          description: 'Căn lề của khối text phía trên',
        },
        media_style: {
          type: 'string',
          enum: ['bordered_rounded', 'plain', 'shadow'],
          description:
            "'bordered_rounded': ảnh có khung bo góc/nền riêng biệt. 'plain': ảnh không khung. 'shadow': ảnh có đổ bóng nổi bật",
        },

        theme_hint: { type: 'string' },
      },
    },

    columns: {
      type: 'array',
      description: "CHỈ dùng khi type_signal='side_by_side'. Theo đúng thứ tự trái→phải, không giới hạn 2 cột",
      items: {
        type: 'object',
        properties: {
          blocks: { type: 'array', items: blockSchema },
        },
        required: ['blocks'],
      },
    },

    blocks: {
      type: 'array',
      description:
        "CHỈ dùng khi type_signal='hero_banner' HOẶC 'text_media_stack'. Stack phẳng theo thứ tự từ trên xuống",
      items: blockSchema,
    },

    content: {
      type: 'object',
      description:
        'CHỈ dùng khi type_signal thuộc: marquee, media_center_grid, faq_accordion, carousel, feature_grid_media, icon_grid_row, stat_list, review_list, freestyle_content. type_signal="text_media_stack" dùng "blocks", KHÔNG dùng "content"',
      properties: {
        heading: { type: 'string' },
        subheading: { type: 'string' },
        body: { type: 'array', items: { type: 'string' } },
        cta: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              label: { type: 'string' },
              url: { type: 'string' },
              style_hint: { type: 'string', enum: ['primary', 'secondary'] },
            },
            required: ['label'],
          },
        },

        marquee_items: {
          type: 'array',
          description: 'CHỈ 1 chu kỳ duy nhất, không lấy toàn bộ DOM đã nhân bản',
          items: {
            type: 'object',
            properties: {
              icon_url: { type: 'string' },
              text: { type: 'string' },
              image_url: { type: 'string' },
              alt: { type: 'string' },
            },
          },
        },

        center_media: {
          type: 'object',
          properties: {
            url: {
              type: 'string',
              description:
                "Với video: lấy từ 'src'/'data-src' của <source>, ưu tiên type='video/mp4'. KHÔNG lấy từ 'poster'.",
            },
            poster_url: {
              type: 'string',
              description: "CHỈ dùng khi media_type='video'. Lấy từ thuộc tính 'poster' của <video>.",
            },
            alt: { type: 'string' },
            media_type: { type: 'string', enum: ['image', 'gif', 'video'] },
          },
        },
        grid_items: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              side: { type: 'string', enum: ['left', 'right'] },
              icon_url: { type: 'string' },
              title: { type: 'string' },
              description: { type: 'string' },
            },
            required: ['side', 'title'],
          },
        },

        faq_items: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              question: { type: 'string' },
              answer: { type: 'string' },
              is_expanded_default: { type: 'boolean' },
            },
            required: ['question', 'answer'],
          },
        },

        section_rating: {
          type: 'object',
          properties: {
            rating_value: { type: 'number' },
            rating_max: { type: 'number' },
            text: { type: 'string' },
          },
        },
        cards: {
          type: 'array',
          description: 'Dùng cho carousel. Mỗi card có blocks giống cấu trúc 1 cột trong side_by_side',
          items: {
            type: 'object',
            properties: {
              blocks: { type: 'array', items: blockSchema },
            },
            required: ['blocks'],
          },
        },

        primary_media: {
          type: 'object',
          properties: {
            url: {
              type: 'string',
              description:
                "Với video: lấy từ 'src'/'data-src' của <source>, ưu tiên type='video/mp4'. KHÔNG lấy từ 'poster'.",
            },
            poster_url: {
              type: 'string',
              description: "CHỈ dùng khi media_type='video'. Lấy từ thuộc tính 'poster' của <video>.",
            },
            alt: { type: 'string' },
            media_type: { type: 'string', enum: ['image', 'gif', 'video'] },
          },
        },
        feature_grid_items: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              media: {
                type: 'object',
                properties: {
                  url: {
                    type: 'string',
                    description:
                      "Với video: lấy từ 'src'/'data-src' của <source>, ưu tiên type='video/mp4'. KHÔNG lấy từ 'poster'.",
                  },
                  poster_url: {
                    type: 'string',
                    description: "CHỈ dùng khi media_type='video'. Lấy từ thuộc tính 'poster' của <video>.",
                  },
                  alt: { type: 'string' },
                  media_type: { type: 'string', enum: ['image', 'gif', 'video'] },
                },
              },
              media_label: { type: 'string' },
              heading: { type: 'string' },
              body: { type: 'string' },
            },
            required: ['heading'],
          },
        },

        icon_grid_items: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              icon_url: { type: 'string' },
              title: { type: 'string' },
              subtitle: { type: 'string' },
            },
            required: ['title'],
          },
        },

        stat_list_items: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              value: { type: 'string' },
              title: { type: 'string' },
              description: { type: 'string' },
            },
            required: ['value', 'title'],
          },
        },
        footer_note: {
          type: 'object',
          properties: {
            icon_url: { type: 'string' },
            text: { type: 'string' },
          },
        },

        review_summary: {
          type: 'object',
          properties: {
            rating_value: { type: 'number' },
            rating_max: { type: 'number' },
            total_reviewers: { type: 'integer' },
            recommend_count: { type: 'integer' },
            recommend_label: { type: 'string' },
            recommend_percent: { type: 'number' },
            cta_text: { type: 'string' },
          },
          required: ['rating_value'],
        },
        reviews: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              author: { type: 'string' },
              title: { type: 'string' },
              content: { type: 'string' },
              rating: { type: 'number' },
              date: { type: 'string' },
              avatar_url: { type: 'string' },
              verified: { type: 'boolean' },
              photos: {
                type: 'array',
                items: {
                  type: 'object',
                  properties: { url: { type: 'string' }, alt: { type: 'string' } },
                  required: ['url'],
                },
              },
            },
            required: ['author', 'content'],
          },
        },

        // ---- freestyle_content ----
        raw_html: {
          type: 'string',
          description:
            "CHỈ dùng cho type_signal='freestyle_content'. Copy Y NGUYÊN toàn bộ HTML bên trong section (giữ đúng thẻ, class, style, thuộc tính), KHÔNG chỉnh sửa, KHÔNG rút gọn, KHÔNG bỏ bất kỳ thẻ nào trừ thuộc tính 'onerror' trên <img>. KHÔNG bao gồm chính thẻ wrapper ngoài cùng.",
        },
      },
    },

    notes: { type: 'string' },
  },
  required: ['type_signal', 'order'],
};

export const tools = {
  name: 'extract_product_page',
  description:
    'Trích xuất TOÀN BỘ dữ liệu có cấu trúc từ HTML trang sản phẩm trong 1 lần gọi duy nhất, gồm 2 phần: ' +
    '(1) "product": thông tin lõi sản phẩm (title, mô tả, variants, options, images, tags, vendor, product type) ' +
    'lấy từ khu vực buy-box; ' +
    '(2) "sections": danh sách các section nội dung marketing bên dưới/xung quanh buy-box ' +
    '(side_by_side, hero_banner, marquee, media_center_grid, faq_accordion, carousel, feature_grid_media, ' +
    'icon_grid_row, stat_list, review_list, freestyle_content, text_media_stack), KHÔNG bao gồm header, footer, và chính buy-box đó.',
  input_schema: {
    type: 'object',
    properties: {
      product: {
        type: 'object',
        description: 'Thông tin lõi sản phẩm, trích xuất từ khu vực buy-box/product hero của trang.',
        properties: {
          title: {
            type: 'string',
            description: 'The main display title of the product.',
          },
          bodyHtml: {
            type: 'string',
            description: 'Full HTML content of the product description.',
          },
          variants: {
            type: 'array',
            description:
              'List of all product variants (available or unavailable), each with its own SKU, price, and option values.',
            items: {
              type: 'object',
              properties: {
                sku: {
                  type: 'string',
                  description: 'The unique stock keeping unit (SKU) identifier if available.',
                },
                price: {
                  type: 'number',
                  description: 'The specific numeric price for this variant, if available.',
                },
                compareAtPrice: {
                  type: 'number',
                  description: 'The original price before any discounts, if available, for comparison.',
                },
                option1: {
                  type: 'string',
                  description: 'The first option value for this variant. Only option value.',
                },
                option2: {
                  type: 'string',
                  description: 'The second option value for this variant, if available. Only option value.',
                },
                option3: {
                  type: 'string',
                  description: 'The third option value for this variant, if available. Only option value.',
                },
                imageSrc: {
                  type: 'string',
                  description: 'The high-resolution image associated with this variant, if available.',
                },
              },
            },
          },
          options: {
            type: 'array',
            description:
              "List of all product options and their possible values, only options from the product's variants are included. Excludes any options that are not represented in the variants and personalized or custom options.",
            items: {
              type: 'object',
              properties: {
                name: {
                  type: 'string',
                  description: 'The name of the option (e.g., Size, Color, Style).',
                },
                values: {
                  type: 'array',
                  description: "All possible values for this option available in the product's variants.",
                  items: { type: 'string' },
                },
              },
              required: ['name', 'values'],
            },
          },
          images: {
            type: 'array',
            description: 'List of all images associated with the product. Excludes review images and thumbnail images.',
            items: {
              type: 'object',
              properties: {
                src: { type: 'string', description: 'The URL to the image.' },
              },
              required: ['src'],
            },
          },
          tags: {
            type: 'array',
            description: 'List of all tags associated with the product for categorization.',
            items: { type: 'string' },
          },
          vendor: {
            type: 'string',
            description: 'The name of the vendor or manufacturer of the product.',
          },
          productType: {
            type: 'string',
            description: 'The specific type or category of the product.',
          },
        },
        required: ['title', 'bodyHtml', 'variants', 'options', 'images', 'tags'],
      },

      sections: {
        type: 'array',
        description:
          'Danh sách các section nội dung marketing, không bao gồm header, footer, hoặc buy-box đã trích ở "product".',
        items: sectionSchema,
      },
    },
    required: ['product', 'sections'],
  },
};
